import * as React from 'react';
import Box from '@mui/material/Box';
import {DataGrid, esES, GridToolbarColumnsButton, GridToolbarContainer} from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton'; // Importar IconButton
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadIcon from "@mui/icons-material/Download";
import TicketModal from 'src/app/main/mesa_servicio_reportes/reportes/result_search/modal';
import { SweetAlertBasic } from "../../../../sweetAlert";
import { getTicketsDet } from '../../../../api/reportes-tickets';
import getIncumplimiento from './tablaIncumplimentoApis';
import { WrapperGrid } from './styles';
import { ExportToExcel } from './export/Export';

const TablaIncumplimiento = () => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [pageSize, setPageSize] = React.useState(6);
  const [openTicketModal, setOpenTicketModal] = React.useState(false);
  const [ticketSelected, setTicketSelected] = React.useState({ row: {} });

  const handlerClose = () => setOpenTicketModal(false);

  const gridRef = React.useRef(null);

  const exportToExcel = () => {
    ExportToExcel(data, columnasIncumplimiento);
  };

  const handleTicketRowClick = (row) => {
    getTicketsDet({
      criticidadTicket: 0,
      tipoFalla: 0,
      ticketStatus: 0,
      tipoTicket: 0,
      tipoRequerimiento: 0,
      numReporteSoc: row.row.numReporteSoc,
      numReporteBestel: '',
    })
      .then((response) => {
        setTicketSelected({ row: response[0] });
        setOpenTicketModal(true);
      })
      .catch((error) => {
        SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
      });
  };

  const fetchData = async () => {
    try {
      const result = await getIncumplimiento(100000, 0);
      setData(result);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const columnasIncumplimiento = [
    { field: 'tiempoEntrega', headerClassName: 'super-app-theme--header', headerName: 'Tiempo de Entrega', flex: 1 },
    { field: 'statusEntrega', headerClassName: 'super-app-theme--header', headerName: 'Status de Entrega', flex: 1 },
    { field: 'causaIncumplimiento', headerClassName: 'super-app-theme--header', headerName: 'Causa de Incumplimiento', flex: 1 },
    { field: 'numReporteSoc', headerClassName: 'super-app-theme--header', headerName: 'No° Reporte SOC', flex: 1 },
    { field: 'numReporteBestel', headerClassName: 'super-app-theme--header', headerName: 'No° Reporte Bestel', flex: 1 },
  ];

  return (
    <>
      <WrapperGrid>
        <strong>Causa de Incumplimiento</strong>
        <Box
          sx={{
            height: 480,
            width: '100%',
            boxShadow: 2,
            borderColor: 'primary.light',
            '& .super-app-theme--header': {
              backgroundColor: '#5E75F2',
              color: 'white',
            },
          }}
          ref={gridRef}
        >
          {loading ? (
            <p>Cargando...</p>
          ) : (
            <DataGrid
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              rows={data}
              columns={columnasIncumplimiento}
              pageSize={pageSize}
              rowsPerPageOptions={[6, 50, 100]}
              pagination
              components={{
                Toolbar: () => (
                  <GridToolbarContainer>
                    <IconButton onClick={() => ExportToExcel(data, columnasIncumplimiento)}>
                      <FileDownloadIcon fontSize="medium" />
                    </IconButton>
                    Exportar a Excel
                  </GridToolbarContainer>
                ),
              }}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
              }}
              onRowClick={handleTicketRowClick}
            />
          )}
        </Box>
      </WrapperGrid>
      <TicketModal openModal={openTicketModal} handlerClose={handlerClose} ticketSel={ticketSelected} />
    </>
  );
};

export default TablaIncumplimiento;
